import { render, staticRenderFns } from "./ItemSelector.vue?vue&type=template&id=79bd8745&scoped=true"
import script from "./ItemSelector.vue?vue&type=script&lang=js"
export * from "./ItemSelector.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=79bd8745&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bd8745",
  null
  
)

export default component.exports